async function getAdvertisements(condition) {
  const resData = await window.axios.get('/api/v1/admin/advertisements', { params: condition });
  return resData.data;
}

async function findAdvertisementById(id) {
  const resData = await window.axios.get(`/api/v1/admin/advertisements/${id}`);
  return resData.data;
}

async function createAdvertisement(params) {
  const resData = await window.axios.post('/api/v1/admin/advertisements', params);
  return resData.data;
}

async function updateAdvertisement(params) {
  const resData = await window.axios.put('/api/v1/admin/advertisements', params);
  return resData.data;
}

async function deleteAdvertisement(id) {
  const resData = await window.axios.delete('/api/v1/admin/advertisements', { params: { id } });
  return resData.data;
}

module.exports = {
  getAdvertisements,
  findAdvertisementById,
  createAdvertisement,
  updateAdvertisement,
  deleteAdvertisement,
};
